import { render, staticRenderFns } from "./404.vue?vue&type=template&id=9b064466&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=9b064466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b064466",
  null
  
)

export default component.exports